import React from "react";
import { formatDateChipLabel } from "./accountingFilterUtils";
import {
  CompactDateInput,
  FieldWrapper,
  FilterSelect,
  FilterToggle,
  FilterSortGroup,
} from "./jobsFilterUtils";

export const ADJUSTMENT_SORT_OPTIONS = [
  { value: "adj_id", label: "ID" },
  { value: "adj_date", label: "Date" },
];

export const ADJUSTMENT_SUBJECT_OPTIONS = [
  { value: "", label: "All" },
  { value: "staff", label: "Staff" },
  { value: "client", label: "Client" },
];

export function AccountingAdjustmentFilterFields({
  focusedFieldId,
  onFocusClear,
  filterFromDate,
  setFilterFromDate,
  filterToDate,
  setFilterToDate,
  filterSubject,
  setFilterSubject,
  filterShowDeleted,
  setFilterShowDeleted,
  sortKey,
  setSortKey,
  sortDir,
  setSortDir,
}) {
  return (
    <>
      <FieldWrapper
        fieldId="fromDate"
        label="From Date"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <CompactDateInput
          id="accounting-adjustment-from"
          value={filterFromDate}
          onChange={setFilterFromDate}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="toDate"
        label="To Date"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <CompactDateInput
          id="accounting-adjustment-to"
          value={filterToDate}
          onChange={setFilterToDate}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="subject"
        label="Subject"
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSelect
          id="accounting-adjustment-subject"
          options={ADJUSTMENT_SUBJECT_OPTIONS}
          value={filterSubject || ""}
          onChange={setFilterSubject}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="showDeleted"
        label=""
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterToggle
          id="accounting-adjustment-show-deleted"
          label="Show Deleted"
          checked={!!filterShowDeleted}
          onChange={setFilterShowDeleted}
        />
      </FieldWrapper>

      <FieldWrapper
        fieldId="sort"
        label=""
        focusedFieldId={focusedFieldId}
        onFocusClear={onFocusClear}
      >
        <FilterSortGroup
          id="accounting-adjustment-sort"
          sortBy={sortKey}
          sortOrder={sortDir}
          onSortByChange={setSortKey}
          onSortOrderChange={setSortDir}
          sortOptions={ADJUSTMENT_SORT_OPTIONS}
        />
      </FieldWrapper>
    </>
  );
}

export function buildAccountingAdjustmentFilterChips({
  searchTerm,
  filterFromDate,
  filterToDate,
  filterSubject,
  filterShowDeleted,
}) {
  const chips = [];

  if (searchTerm) {
    chips.push({
      id: "search",
      key: "search",
      fieldId: "search",
      label: `Search: ${searchTerm}`,
    });
  }

  if (filterFromDate) {
    chips.push({
      id: "fromDate",
      key: "fromDate",
      fieldId: "fromDate",
      label: formatDateChipLabel(filterFromDate).replace(/^Date: /, "From: "),
    });
  }

  if (filterToDate) {
    chips.push({
      id: "toDate",
      key: "toDate",
      fieldId: "toDate",
      label: formatDateChipLabel(filterToDate).replace(/^Date: /, "To: "),
    });
  }

  if (filterSubject) {
    const matched = ADJUSTMENT_SUBJECT_OPTIONS.find((o) => o.value === filterSubject);
    chips.push({
      id: "subject",
      key: "subject",
      fieldId: "subject",
      label: `Subject: ${matched ? matched.label : filterSubject}`,
    });
  }

  if (filterShowDeleted) {
    chips.push({
      id: "showDeleted",
      key: "showDeleted",
      fieldId: "showDeleted",
      label: "Show Deleted",
    });
  }

  return chips;
}
